import {
  QuestionMarkIcon_default
} from "./chunk-GOOPCPP7.js";
import {
  muiMergeSx
} from "./chunk-F3QHBCNP.js";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BBZEL7EG.js";

// src/HelperButton.tsx
import { lazyLoad } from "@levana-protocol/utils/lazyLoad";
import { useModal } from "@levana-protocol/utils/modal";
import IconButton from "@mui/joy/IconButton";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var HelperButton = forwardRef(
  (props, ref) => {
    const _a = props, { modal, onClick, sx } = _a, joyProps = __objRest(_a, ["modal", "onClick", "sx"]);
    const { present } = useModal();
    return /* @__PURE__ */ jsx(
      IconButton,
      __spreadProps(__spreadValues({
        color: "neutral",
        variant: "soft",
        "aria-label": "help"
      }, joyProps), {
        ref,
        onClick: (event) => __async(void 0, null, function* () {
          onClick == null ? void 0 : onClick(event);
          if (modal) {
            const HelperModal = yield lazyLoad(() => import("./HelperModal.js"));
            present(/* @__PURE__ */ jsx(HelperModal, { title: modal.title, message: modal.message }));
          }
        }),
        sx: [
          {
            "--IconButton-size": "1rem",
            "--Icon-fontSize": "calc(var(--IconButton-size) / 1.2)",
            color: "text.secondary",
            paddingInline: 0
          },
          (theme) => muiMergeSx(theme, sx)
        ],
        children: /* @__PURE__ */ jsx(QuestionMarkIcon_default, {})
      })
    );
  }
);
var HelperButton_default = HelperButton;

export {
  HelperButton_default
};
